/* Cart drawer variant swap (replaces Kaching Cart). */
(function () {
  if (window.kcVariantSwap) return;
  window.kcVariantSwap = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
  function post(path, body) {
    return fetch(root + path, { method: 'POST', headers: headers, body: JSON.stringify(body) }).then(function (r) {
      if (!r.ok) throw new Error('Cart request failed');
      return r.json();
    });
  }
  function refresh() {
    var form = document.querySelector('cart-drawer cart-form');
    if (form && typeof form.refresh === 'function') { form.refresh(); } else { window.location.reload(); }
  }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('.kc-item__opt') : null;
    if (!sel) return;
    var item = sel.closest('.kc-item');
    var data = item.querySelector('.kc-item__variants');
    var msg = item.querySelector('.kc-item__msg');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var chosen = Array.prototype.map.call(item.querySelectorAll('.kc-item__opt'), function (s) { return s.value; });
    var match = variants.find(function (v) { return v.o.every(function (o, i) { return o === chosen[i]; }); });
    if (!match || !match.a) { if (msg) msg.hidden = false; return; }
    if (msg) msg.hidden = true;
    item.classList.add('kc-item--loading');
    var key = item.getAttribute('data-key');
    var oldVariant = item.getAttribute('data-variant');
    var qty = parseInt(item.getAttribute('data-qty'), 10) || 1;
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var idx = cart.items.findIndex(function (i) { return i.key === key; });
        if (idx < 0) idx = cart.items.findIndex(function (i) { return String(i.variant_id) === oldVariant; });
        if (idx < 0) throw new Error('Line not found');
        qty = cart.items[idx].quantity;
        return post('cart/change.js', { line: idx + 1, quantity: 0 });
      })
      .then(function () { return post('cart/add.js', { items: [{ id: match.id, quantity: qty }] }); })
      .then(refresh)
      .catch(function () { refresh(); });
  });
})();
